const storyboardsSection = $('#storyboards-section');
const storyboardSlider = storyboardsSection.find('.slider-nav-parent');
const storyboardsPagesList = storyboardsSection.find('.storyboards-parent');
const storyboardsPages = storyboardsSection.find('.storyboards-page');
const storyboardsCards = storyboardsSection.find('.storyboards-card-placer');
const storyboardPopup = $('.storyboards-popup');
const storyboardPopupClose = storyboardPopup.find('.storyboards-popup-close');
const storyboardPopupBG = storyboardPopup.find('.storyboards-popup-bg');
const storyboardPopupInner = storyboardPopup.find('.storyboards-popup-inner');
const navBtns = storyboardSlider.find('.slider-nav-btn');

let storyboardsListTL, storyboardToperListInTL;
let storyboardLastPage = 0;
let activePlayer = null;

const storyboardCardHover = (card, direction) => {
  const cardImageParent = card.find('.storyboards-card-image-parent');
  const cardPlayIcon = card.find('.storyboards-card-play-icon');
  const isBig = card.hasClass('big');

  const toWidth =
    direction == 1
      ? isBig ? '33.688vw' : '15.25vw'
      : isBig ? '30.625vw' : '13.75vw';

  gsap.to(cardImageParent, {
    height: toWidth,
    duration: 0.667,
    ease: 'tagInEasing',
    overwrite: 'auto',
  });

  gsap.to(cardPlayIcon, {
    opacity: direction == 1 ? 1 : 0,
    duration: 0.667,
    ease: 'tagInEasing',
    overwrite: 'auto',
  });
};

const showStoryboardPopup = (player, immediate) => {
  activePlayer = player;

  const popupTL = gsap.timeline({
    paused: true,
    onStart: () => {
      lenis.stop();
    },
    onComplete: () => {
      player.playVideo();

      storyboardPopupClose.on('click', () => {
        storyboardPopupClose.off('click');
        popupTL.reverse();
      });
    },
    onReverseComplete: () => {
      lenis.start();
      gsap.set(storyboardPopup, { pointerEvents: 'none' });

      const url = new URL(window.location);
      url.searchParams.delete('storyboard');
      window.history.replaceState({}, '', url);

      if (activePlayer) {
        activePlayer.destroy();
        activePlayer = null;
      }
    },
  });

  popupTL.add(
    gsap.set(storyboardPopup, {
      display: 'flex',
      pointerEvents: 'all',
    }),
    0
  );

  popupTL.add(
    gsap.fromTo(
      storyboardPopupBG,
      { opacity: 0 },
      {
        opacity: 0.8,
        duration: 0.667,
        ease: 'opacityInEasing',
      }
    ),
    0
  );

  popupTL.add(
    gsap.fromTo(
      storyboardPopupInner,
      { y: '100vw' },
      {
        y: 0,
        duration: 0.667,
        ease: 'pageInEasing',
      }
    ),
    0
  );

  if(!immediate){
    popupTL.play();
  } else {
    popupTL.progress(1);
  }
};

const storyboardVideoToPopup = (card, pushState = true, immediate = false) => {
  const cardVideoURL = card.attr('data-video-url');
  const cardHandle = card.attr('data-storyboard-handle');

  if (pushState && cardHandle) {
    const url = new URL(window.location);
    url.searchParams.set('storyboard', cardHandle);
    window.history.pushState({}, '', url);
  }

  const cardVideoID =
    (cardVideoURL.split('v=')[1] || '').split('&')[0] || '';

  const player = new YT.Player('storyboard-player', {
    height: '360',
    width: '640',
    videoId: cardVideoID,
    playerVars: {
      autoplay: 0,
      rel: 0,
    },
    events: {
      onReady: () => showStoryboardPopup(player, immediate),
    },
  });
};

const storyboardCardsIn = () => {
  const firstPageCards = storyboardsPages
    .slice(storyboardLastPage)
    .find('.storyboards-card-placer');

  const cardsInTL = gsap.timeline({ paused: true });

  cardsInTL.add(
    gsap.fromTo(
      firstPageCards,
      { x: '98.125vw', opacity: 0 },
      {
        x: 0,
        opacity: 1,
        duration: 1,
        ease: 'tagInEasing',
        stagger: 0.1,
      }
    ),
    0
  );

  return cardsInTL;
};

const storyboardScrollPage = (slider, sliderObject, direction, from, to) => {
  const prevCards = sliderObject.slice(from).find('.storyboards-card-placer');
  const nextCards = sliderObject.slice(to).find('.storyboards-card-placer');
  const allCards = $('.storyboards-card-placer');

  const excludedCards = prevCards.add(nextCards);
  const remainingCards = allCards.not(excludedCards);

  const pageWidth = pxToVw(storyboardsPages.eq(0).outerWidth());
  const pagesGap = pxToVw(Number(storyboardsPagesList.css('gap').replace('px', '')));
  const offset = pageWidth + pagesGap;

  gsap.to(prevCards, {
    x: `${-offset * to}vw`,
    duration: 1,
    ease: 'tagInEasing',
    stagger: {
      each: 0.03,
      from: direction == 1 ? 'start' : 'end',
    },
  });
  gsap.to(nextCards, {
    x: `${-offset * to}vw`,
    duration: 1,
    ease: 'tagInEasing',
    stagger: {
      each: 0.033,
      from: direction == 1 ? 'start' : 'end',
    },
    delay: direction == 1 ? 0.165 : 0,
    onComplete: () => slider.attr('data-is-blocked', 'none'),
  });
  if (remainingCards.length != 0) {
    gsap.set(remainingCards, {
      x: `${-offset * to}vw`,
    });
  }
};

const changeSliderControls = () => {
  storyboardsCards.each(function () {
    const card = $(this);
    const cardImage = card.find('.storyboards-card-image-parent');

    gsap.killTweensOf(cardImage);
    gsap.set(cardImage, { clearProps: 'all' });

    card.off('mouseenter mouseleave click');

    if (isDesktop()) {
      card.on('mouseenter', () => storyboardCardHover(card, 1));
      card.on('mouseleave', () => storyboardCardHover(card, 0));
    }

    card.on('click', () => storyboardVideoToPopup(card));
  });
};

const storyboardListIn = () => {
  const sectionTopperInTL = gsap.timeline({ paused: true });
  const sectionInTL = gsap.timeline({ paused: true });

  sectionTopperInTL.add(
    animateSectionTopperIn({
      sectionParent: storyboardsSection,
      gradient: 'linear-gradient(127deg, #959698ff 0%, #8AD1DA 50%, #081B48 100%)',
      start: 120,
      end: 0,
    }).play(),
    0
  );

  sectionInTL.add(storyboardCardsIn().play(), 0.5);

  return [sectionTopperInTL, sectionInTL];
};

const openStoryboardFromURL = () => {
  const handle = new URLSearchParams(window.location.search).get('storyboard');
  if (!handle) return ;

  const card = $(`.storyboards-card-placer[data-storyboard-handle="${handle}"]`);
  if (!card.length) return ;

  requestAnimationFrame(() => {
    storyboardVideoToPopup(card, false, true);
  });
};

const initStoryboardList = () => {
  changeSliderControls();

  $(window).on('deviceChange', changeSliderControls);

  addStepAnimation(storyboardSlider, storyboardsPages, storyboardScrollPage);
  addSliderInAnimation(storyboardSlider, true, 50, true);

  if(isDesktop()){
    [storyboardToperListInTL, storyboardsListTL] = storyboardListIn();

    ScrollTrigger.create({
      trigger: storyboardsSection,
      start: 'top top+=120%',
      end: 'top top',
      once: true,
      onUpdate: (self) => {
        storyboardToperListInTL.progress(self.progress);
      },
    });

    ScrollTrigger.create({
      trigger: storyboardsSection,
      start: 'top+=30% bottom',
      end: 'top top',
      once: true,
      onEnter: () => {
        storyboardsListTL.play();
      },
    });
  }
};

/*
$(window).on('load', function(){
  initStoryboardList();
})
*/

addSectionObserver(storyboardsSection, initStoryboardList);
